import React from "react";

interface IconProps {
  className?: string;
}

const OccupantsIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12 12"
    className={className ? className : "w-4 h-4"}
  >
    <path
      fill="currentColor"
      d="M2.5 6a1 1 0 0 0 0-2 1 1 0 0 0 0 2m7 0a1 1 0 0 0 0-2 1 1 0 0 0 0 2m.5.5H9a1 1 0 0 0-.705.29c.63.346 1.077.97 1.174 1.71H10.5A.5.5 0 0 0 11 8v-.5a1 1 0 0 0-1-1m-4 0A1.75 1.75 0 1 0 6 3a1.75 1.75 0 1 0 0 3.5m1.2.5h-.13c-.325.156-.686.25-1.07.25S5.256 7.156 4.93 7H4.8A1.8 1.8 0 0 0 3 8.8v.45c0 .414.336.75.75.75h4.5A.75.75 0 0 0 9 9.25V8.8A1.8 1.8 0 0 0 7.2 7m-3.495-.21A1 1 0 0 0 3 6.5H2a1 1 0 0 0-1 1V8a.5.5 0 0 0 .5.5h1.03a2.29 2.29 0 0 1 1.175-1.71"
    ></path>
  </svg>
);

export default OccupantsIcon;
